import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "aria-label"]
const _hoisted_2 = { class: "mr-0 md:mr-4 text-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.contact.url,
    target: "_blank",
    rel: "noopener noreferrer",
    class: "relative flex items-center w-fit md:flex-row-reverse md:ml-auto animate-underline",
    "aria-label": _ctx.contact.aria
  }, [
    _createVNode(_component_FontAwesomeIcon, {
      icon: _ctx.contact.icon,
      size: "2x",
      class: "text-secondary mr-4 md:mr-0 w-7 h-7"
    }, null, 8, ["icon"]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.contact.label), 1)
  ], 8, _hoisted_1))
}